export class GetTableSampleResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<Array<TableSampleCell>>",
            "format": ""
        },
        {
            "name": "filesRead",
            "baseName": "filesRead",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableSampleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
